import React, { useEffect } from "react";
import Team from "../components/templates/Team";
import AchievementsTimeline from "../components/templates/AchievementsTimeline";
import TotalIndemnifications from "../components/templates/TotalIndemnifications";
import heroBg from "../assets/images/logo-free-predio.webp";
import Equipe from "../assets/images/time/equipe.JPG";
const About = () => {
  // Força a rolagem para o topo assim que o componente monta
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* Seção com background com overlay */}
      <section
        className="bg-cover bg-center py-32"
        style={{
          backgroundImage: `radial-gradient(circle, rgba(60, 200, 252, 0.45) 0%, rgba(9, 25, 55, 0.9) 100%), url(${heroBg})`,
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-2xl xs:text-3xl md:text-5xl font-bold text-white mb-4">
            Sobre a Free Market Seguros
          </h1>
          <p className="text-sm xs:text-base md:text-xl text-white">
            Conheça a trajetória da Free Market Seguros
          </p>
        </div>
      </section>

      {/* Conteúdo principal */}
      <div className="py-16 container mx-auto px-4">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden mb-12 mx-auto">
          <div className="p-8">
            <h2 className="text-3xl sm:text-4xl font-bold text-blue-950 mb-6 max-w-5xl mx-auto">
              Nossa História: Segurança e Tranquilidade para o seu Futuro
            </h2>

            <div className="space-y-6 max-w-5xl mx-auto">
              <p className="text-lg sm:text-xl text-blue-950 text-justify">
                Desde 2003, a Free Market Seguros tem uma missão clara: proteger
                o que é mais valioso para você. Nascemos em São Gotardo (MG) e,
                com muito trabalho, ética e dedicação, crescemos e nos tornamos
                uma das corretoras mais respeitadas da região.
              </p>

              <p className="text-lg sm:text-xl text-blue-950 text-justify">
                Ao longo de nossa trajetória, unimos a experiência de mais de 20
                anos com as mais modernas soluções tecnológicas para oferecer um
                atendimento ágil e personalizado. Para nós, cada cliente é
                único, e essa proximidade é o que nos move a buscar sempre as
                melhores opções no mercado de seguros.
              </p>

              <p className="text-lg sm:text-xl text-blue-950 text-justify">
                Hoje, já são mais de 25 mil famílias protegidas em todo o
                Brasil, um número que reflete a confiança depositada em nosso
                trabalho. Continuamos comprometidos em garantir a sua
                tranquilidade, oferecendo segurança e um atendimento de
                excelência.
              </p>

              <p className="text-lg sm:text-xl font-bold text-blue-950 text-justify">
                Free Market Seguros: Proteção para hoje, tranquilidade para
                sempre.
              </p>
            </div>

            <div className="h-64 md:h-full flex items-center justify-center overflow-hidden mt-8">
              <img
                src={Equipe}
                alt="Equipe"
                className="object-contain h-full w-full rounded-3xl"
              />
            </div>
          </div>
        </div>

        <Team />

        <AchievementsTimeline />

        <TotalIndemnifications repeat={true} repeatDelay={20000} />

        <div className="px-6 max-w-7xl mx-auto pb-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-blue-950 mb-4 text-center pb-8">
            Nossos Valores
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="bg-blue-200 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-handshake text-blue-950 text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-blue-950 mb-3">
                Comprometimento
              </h3>
              <p className="text-gray-600">
                Estamos sempre ao lado dos nossos clientes, oferecendo suporte
                em todos os momentos, especialmente quando mais precisam.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="bg-blue-200 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-shield-alt text-blue-950 text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-blue-950 mb-3">
                Confiança
              </h3>
              <p className="text-gray-600">
                Construímos relacionamentos duradouros baseados na
                transparência, honestidade e no cumprimento de nossas promessas.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="bg-blue-200 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-chart-line text-blue-950 text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-blue-950 mb-3">
                Excelência
              </h3>
              <p className="text-gray-600">
                Buscamos constantemente a melhoria de nossos processos e
                serviços para oferecer as melhores soluções do mercado.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-blue-950 text-white p-8 rounded-lg shadow-lg">
          <div className="md:flex items-center">
            <div className="md:w-2/3 mb-6 md:mb-0">
              <h2 className="text-2xl font-bold mb-4">
                Quer fazer parte da nossa história?
              </h2>
              <p className="text-blue-100">
                Entre em contato conosco e descubra como podemos ajudar você a
                proteger o que mais importa.
              </p>
            </div>
            <div className="md:w-1/3 text-center">
              <a
                href="/contato"
                className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-md font-medium inline-block"
              >
                Fale Conosco
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
